import * as React from "react";
import { ExternalLink } from "../../../../newcomponents/table/components/ExternalLink";
import { DOCS_URL } from "../../../../envVariables";
import { Alert, Divider } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
interface Props {}
export const AddonAwsEcr: React.FC<Props> = ({}) => {
  const provider = useCpFormValue(`provider`);

  const isEnabled = useCpFormValue(`addons.awsECR.isEnabled`);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        Add-On | AWS ECR
      </Divider>
      <div id={`addon-awsECR`} style={{ scrollMarginTop: 200 }}>
        <Alert
          className="mb-4 w-fit"
          type={"info"}
          message="Documentation"
          description={
            <div className="flex items-end gap-1">
              <ExternalLink url={`${DOCS_URL}/mk8s/add-ons/aws_ecr`} label={`Click here`} disableCopy />
              <div>for learning how to configure the addon.</div>
            </div>
          }
        />
        {provider === "aws" ? (
          <Alert
            className="mb-4 w-fit"
            type={`info`}
            showIcon
            message="Role ARN is optional with AWS Provider, by default it will use the instance role to pull images."
          />
        ) : null}
        <CpFormItem>
          <CpLabel name={`addons.awsECR.roleArn`}>Role ARN</CpLabel>
          <CpInput name={`addons.awsECR.roleArn`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`addons.awsECR.roleArn`} />
        </CpFormItem>
      </div>
    </>
  );
};
